<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>视频列表 > <b>MC任务</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span>
            <span class="search_span_width_part1" style="margin-left: 10px;">用户ID：</span>
            <Input v-model="search.user_id"  style="width: 100px" />
          </span>
          <span>
            <span class="search_span_width_part1" style="margin-left: 10px;">任务名称：</span>
            <Input v-model="search.name"  style="width: 100px" />
          </span>`
          <span>
            <span class="search_span_width_part1" style="margin-left: 10px;">数字人分组ID：</span>
            <Input v-model="search.figure_group_id"  style="width: 100px" />
          </span>
          <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
      </Card>
      <Card id="tableContent" >
        <Table :columns="tableColumns" :data="data_list"></Table>
        <Page :total="total" :current="search.page" :page-size=search.pageSize :show-elevator="true" @on-change="getList"/>
      </Card>
    </Content>
    <Modal
        v-model="showDetail"
        width="800"
        footer-hide
        title="查看详情">
      <Table :columns="studioColumn" :data="studio_list"></Table>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data() {
    return {
      search:{
        page:1,
        pageSize: 10,
        user_id:"",
        mc_task_id:"",
        figure_group_id:"",
        name:""
      },
      total:0,
      showDetail:false,
      data_list:[],
      studio_list:[],
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center',width: 100,"fixed": "left" },
        { title: '任务名称', key: 'name', align: 'center', width: 200,"fixed": "left" },
        { title: '任务ID', key: 'mc_task_id', align: 'center', width: 200 },
        { title: '用户ID', key: 'user_id', align: 'center',width: 100 },
        { title: '数字人分组ID', key: 'figure_group_id', align: 'center',width: 150 },
        { title: '是否生成预览', key: 'is_preview', align: 'center',width: 100, render: (h, params) => {
            let txt = '';
            if(params.row.is_preview=='0'){
              return h('span',{},"否");
            }
            if(params.row.is_preview==1){
              return h('span',{},"待生成");
            }
            if(params.row.is_preview==2){
              return h('span',{},"生成中");
            }
            if(params.row.is_preview==3){
              return h('span',{},"生成失败");
            }
            if(params.row.is_preview==4){
              return h('span',{},"已生成");
            }
          }
        },
        { title: '生成数量', key: 'task_num', align: 'center',width: 100 },
        { title: '数据响应', key: 'response', align: 'center', width: 300},
        { title: '创建时间', key: 'created_at', align: 'center' ,width: 200},
        {
          title: '操作', key: 'action', fixed: 'right', align: 'center', width: '160px',
          render: (h, params) => {
            let btns = []
            btns.push(
                h('Button', {
                  props: {type: 'primary', size: 'small'},
                  style: {marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.getStudioList(params.row.id)
                    }
                  }
                }, '查看详情'),
            );
            return h("div",btns);
          }
        }
      ],
      studioColumn:[
        { title: 'ID', key: 'id', align: 'center', },
        { title: '名字', key: 'name', align: 'center' },
        { title: '状态', key: 'status', align: 'center' },
        { title: '数字人ID', key: 'figure_id', align: 'center' },
        { title: '发音人ID', key: 'spk_id', align: 'center'},
        { title: '创建时间', key: 'created_at', align: 'center',width:200},
      ]
    }
  },
  mounted:function(){
    this.getList()
  },
  methods:{
    getList(page=1){
      this.search.page = page;
      this.http1.get('/mc_job/getList',{params:this.search}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.data_list = data.data.list;
          this.total = data.data.total

        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getStudioList(id){
      this.http1.get('/mc_job/getStudioInfo',{params:{id:id}}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.studio_list = data.data;
          this.showDetail = true;

        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    }
  }
}
</script>



<style scoped>

</style>